<template>
  <div class="sidebar-logo-container" :class="{ collapse: collapse }">
    <transition name="sidebarLogoFade">
      <router-link v-if="collapse" key="collapse" class="sidebar-logo-link" to="/">
        <img :src="logo" class="sidebar-logo" />
      </router-link>
      <router-link v-else key="expand" class="sidebar-logo-link" :to="redirect">
        <!-- <img :src="logo" class="sidebar-logo" /> -->
        <div class="sidebar-logo-text">
         G-Media
        </div>
      </router-link>
    </transition>
  </div>
</template>

<script>
import logo from '@/assets/logo.jpg'

export default {
  name: 'SidebarLogo',
  props: {
    collapse: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      title: 'Media Score',
      logo: logo,
      redirect: '/'
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/variables.scss';

.sidebarLogoFade-enter-active {
  transition: opacity 1.5s;
}

.sidebarLogoFade-enter,
.sidebarLogoFade-leave-to {
  opacity: 0;
}

.sidebar-logo-container {
  position: relative;
  width: 100%;
  height: 94px;
  padding-left: 24px;
  line-height: 64px;
  background: #ffffff;
  text-align: left;
  border-right: 1px solid #E2E2EA;
  overflow: hidden;

  .sidebar-logo-text {
    font-size: 28px;
    font-weight: 700;
    color: #3b82f6;
    line-height: 64px;
    letter-spacing: 6px;
    text-align: center;
    width: 100%;
    padding-right: 24px;
  }

  & .sidebar-logo-link {
    height: 100%;
    width: 100%;
    display: flex;
    align-items: center;

    & .sidebar-logo {
      display: inline-block;
      height: 52px;
      vertical-align: middle;
      margin-left: 0;
    }

    & .sidebar-title {
      display: inline-block;
      margin: 0;
      color: #222;
      font-weight: 700;
      line-height: 64px;
      font-size: 18px;
      font-family: Avenir, Helvetica Neue, Arial, Helvetica, sans-serif;
      vertical-align: middle;
      letter-spacing: 0.5px;
    }

    & .ver {
      position: absolute;
      bottom: 14px;
      line-height: 1;
      display: inline-block;
      vertical-align: middle;
      font-size: 12px;
      padding-left: 5px;
      color: #b0b8c9;
    }
  }

  &.collapse {
    padding-left: 11px;

    .sidebar-logo {
      height: 28px;
      margin-right: 0;
      margin-left: 0;
    }

    .sidebar-title {
      display: none;
    }
  }
}
</style>
